<div class="banner">
  <div class="container">
    <h1>{{heading}}</h1>
    <p>{{detail}}</p>
  </div>
</div>